import { FormControl, Validators } from '@angular/forms';
// tslint:disable-next-line
export const PHONE_VALIDATOR_REGEX = /^$|^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$/;
export const WEBSITE_VALIDATOR_REGEX = /^$|(http[s]?:\/\/)?[^\s(["<,>]*\.[^\s[",><]*/;
export const CBRE_VALIDATORS = (() => {
  /** @param { min, max } override validators min and max value */
  const minAndMaxValidators = ({ min = 0, max = Number.MAX_SAFE_INTEGER }) => [
    Validators.min(min),
    Validators.max(max),
  ];
  const phoneValidator = (c: FormControl) => {
    return !c.value || PHONE_VALIDATOR_REGEX.test(c.value) ? null : { validPhone: { valid: false } };
  };
  const websiteValidator = (c: FormControl) => {
    return WEBSITE_VALIDATOR_REGEX.test(c.value) ? null : { website: { valid: false } };
  };
  const shouldNotBeEqualToValidator = (valueNotEqualTo: any, type: string) => (c: FormControl) => {
    let isValid: boolean;
    switch (type) {
      case 'number':
        isValid = parseFloat(c.value) !== valueNotEqualTo;
        break;
      case 'text':
        isValid = c.value !== valueNotEqualTo.toString();
        break;
      default:
        isValid = c.value !== valueNotEqualTo;
    }
    return isValid ? null : { shouldNotBeEqualToValidator: { valid: false } };
  };
  /** min 0, max Number.MAX_SAFE_INTEGER */
  return {
    defaultMinMaxValidators: minAndMaxValidators({}),
    minAndMaxValidators,
    phoneValidator,
    websiteValidator,
    shouldNotBeEqualToValidator,
  };
})();
